import React, { useEffect, useState } from "react";
import { Field } from "formik";
import "../style.scss";
import { FormControl, FormLabel, Input, Box, FormErrorMessage, Spinner } from "@chakra-ui/react";
import CalendarIcon2, { EditFormIcon } from "~misc/icons";
import useModalPrice from "~components/Modal/hooks/useModalPrice";
import ModalPriceSearch from "~components/Modal/ModalPriceSearch";
import Info from "~components/Form/components/Info";

const InputField = ({
  inputName,
  inputMask,
  inputType,
  as,
  mask,
  labelName,
  tooltip,
  setValue,
  onWheel,
  values,
  onBlur,
  isDisabled,
  calendarIcon,
  hasImage,
  setFieldValue,
  defaultValue,
  setFieldTouched,
  isRequired,
  customClasses,
  difference,
  loading,
  onChangeEvent,
  onKeyDown,
  onInput,
  valuesInputs,
  setValuesInputs,
  forceUppercase,
  validate,
  ...rest
}) => {
  const { isModalOpenPrice, closeModalPrice, openModalPrice } = useModalPrice();
  const [isImageVisible, setIsImageVisible] = useState("true");
  const [error, setError] = useState();

  const verifyAutoComplete = (e) => {
    const name = e.target.name;

    //  PREVENT AUTOCOMPLETE
    if (preventAutoComplete.includes(name) && e.target != document.activeElement) {
      e.target.value = "";
      e.target.classList.add("preventAutoComplete");
    }
  };

  useEffect(() => {
    if (error == "volume/preço menor ou igual a zero") {
      openModalPrice();
    }
  }, [error, openModalPrice]);

  useEffect(() => {
    if (defaultValue != undefined && defaultValue != "") {
      if (setFieldValue) setFieldValue(inputName, defaultValue);
      if (setFieldTouched) {
        setTimeout(() => setFieldTouched(inputName, true));
      }
    }
  }, [defaultValue, setFieldValue, inputName, setFieldTouched]);
  return (
    <>
      <Field name={inputName} validate={validate}>
        {({ field, meta, form }) => {
          const shouldShowError = Boolean(meta.error) && (meta.touched || form.submitCount > 0);

          return (
            <FormControl isInvalid={shouldShowError} className={isDisabled == true ? "desabilitar " : "normal"}>
              <FormLabel className={`field__label ${isDisabled ? "text-[#C6C6C6] " : ""} ${tooltip ? "!flex !items-center !gap-x-2" : ""}`}>
                {labelName} {isRequired && <span className="text-red-500">*</span>} {tooltip && <Info bg="blue" position="mobile-left" text={tooltip} tooltipClass="w-6 h-6 relative" />}
              </FormLabel>
              <Box position="relative" className={difference && "bg-white rounded-md"}>
                {inputMask == "offmask" ? (
                  <Input
                    className={`search-wrapper searchWrapper input-field ${customClasses ?? ""}`}
                    type={inputType}
                    {...field}
                    onKeyDown={onKeyDown}
                    onInput={onInput}
                    onChange={async (e) => {
                      verifyAutoComplete(e);
                      if (forceUppercase && e.target.value) {
                        e.target.value = e.target.value.toUpperCase();
                      }
                      field.onChange(e);

                      if (setValuesInputs) {
                        setValuesInputs({
                          ...valuesInputs,
                          [inputName]: e.target.value,
                        });
                      }
                      if (values) {
                        setValue({
                          ...values,
                          name: e.target.name,
                          value: e.target.value,
                        });
                      }
                      onChangeEvent ? await onChangeEvent(e) : null;
                    }}
                    onWheel={onWheel}
                    onBlur={(e) => {
                      field.onBlur(e);
                      setIsImageVisible(true);
                    }}
                    onClick={(e) => {
                      setIsImageVisible(false);
                    }}
                    disabled={isDisabled ? isDisabled : false}
                    {...rest}
                  />
                ) : (
                  <div className="flex items-center">
                    <Input
                      as={as}
                      mask={mask}
                      type={inputType}
                      keepCharPositions={true}
                      placeholderChar={"\u2000"}
                      className={customClasses ?? " input-field"}
                      guide={false}
                      {...field}
                      style={{
                        paddingLeft: calendarIcon && "2rem",
                      }}
                      onKeyDown={onKeyDown}
                      onInput={onInput}
                      onChange={async (e) => {
                        verifyAutoComplete(e);
                        if (forceUppercase && e.target.value) {
                          e.target.value = e.target.value.toUpperCase();
                        }
                        field.onChange(e);
                        if (setValuesInputs) {
                          setValuesInputs({
                            ...valuesInputs,
                            [inputName]: e.target.value,
                          });
                        }
                        if (values) {
                          setValue({
                            ...values,
                            name: e.target.name,
                            value: e.target.value,
                          });
                        }
                        onChangeEvent ? await onChangeEvent(e) : null;
                      }}
                      {...rest}
                      onWheel={onWheel}
                      onBlur={(e) => {
                        field.onBlur(e);
                        setIsImageVisible("true");
                        if (onBlur) onBlur(e);
                        setIsImageVisible(true);
                      }}
                      onClick={(e) => {
                        setIsImageVisible(false);
                      }}
                      disabled={isDisabled ? isDisabled : false}
                    />
                    {loading ? <Spinner size={"sm"} className="absolute right-2" /> : null}
                  </div>
                )}
                {hasImage && isImageVisible && (
                  <span
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  >
                    <EditFormIcon />
                  </span>
                )}

                {calendarIcon && (
                  <span
                    style={{
                      position: "absolute",
                      left: "10px",
                      top: "54%",
                      transform: "translateY(-50%)",
                    }}
                  >
                    <CalendarIcon2 />
                  </span>
                )}
              </Box>
              {/* {meta.touched && meta.error && setError(meta.error)} */}
              {shouldShowError && <FormErrorMessage>{meta.error}</FormErrorMessage>}

              <ModalPriceSearch
                isOpen={isModalOpenPrice}
                onClose={() => {
                  closeModalPrice();
                }}
                title="Aviso!"
                sub={
                  <>
                    <p className="font-bold max-w-[200px]">volume/preço menor ou igual a zero</p>
                  </>
                }
                buttonOne={null}
                buttonTwo="Ok"
                linkOne={null}
                linkTwo={null}
              />
            </FormControl>
          );
        }}
      </Field>
    </>
  );
};

export default InputField;

const preventAutoComplete = ["cep", "rua", "numero", "bairro", "complemento", "cidadeId", "uf"];
